<div class="page-root">
  <div class="page-wide-column-body">
    <div class="page-column">
      <div class="title">
        <mat-icon>lock</mat-icon>
      </div>

      <div class="title">
        <div class="typo-h1">{{ "passwordSetup.title" | transloco }}</div>
      </div>

      <div [formGroup]="setPasswordForm" class="body">
        <div class="body-text">
          {{ "passwordSetup.subtitle.body" | transloco }}
          <br><br>
          {{ "passwordSetup.subtitle.appendix" | transloco }}
        </div>

        <mat-form-field class="form-field" hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ "form.label.verificationCode" | transloco }}</mat-label>
          <input autocomplete="off" data-1p-ignore data-bwignore="true" data-lpignore="true" data-protonpass-ignore="true" formControlName="verificationCode" matInput/>
        </mat-form-field>

        <mat-form-field class="form-field" hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ "form.label.password" | transloco }}</mat-label>
          <input [type]="hidePassword ? 'password' : 'text'" formControlName="password" matInput>
          <app-icon-button (click)="togglePasswordVisibility()" [colorVariant]="isPasswordValid ? 'transparent' : 'transparent-error'" [icon]="hidePassword ? 'visibility_off' : 'visibility'"
                           matSuffix/>
          <mat-error>{{ 'form.validation.password' | transloco }}</mat-error>
        </mat-form-field>

        <mat-form-field class="form-field" hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ "form.label.passwordRepeat" | transloco }}</mat-label>
          <input [type]="hidePasswordRepeat ? 'password' : 'text'" formControlName="passwordRepeat" matInput>
          <app-icon-button (click)="togglePasswordRepeatVisibility()" [colorVariant]="isPasswordRepeatValid ? 'transparent' : 'transparent-error'"
                           [icon]="hidePasswordRepeat ? 'visibility_off' : 'visibility'"
                           matSuffix/>
          <mat-error>{{ 'form.validation.password' | transloco }}</mat-error>
        </mat-form-field>

        @if (passwordMatch) {
          <mat-error class="error">{{ 'form.validation.passwordMatch' | transloco }}</mat-error>
        }
      </div>
      @if (error) {
        <mat-error>{{ error }}</mat-error>
      }

      <div class="actions">
        <app-text-button (click)="setPassword()" [text]="'passwordSetup.button' | transloco" colorVariant="primary" trailingIcon="check_circle" type="rounded"></app-text-button>
      </div>
    </div>
  </div>
</div>
